// extracted by mini-css-extract-plugin
export default {"content":"Alert_content__sJKnT","withTitle":"Alert_withTitle__YXEgZ","titleRow":"Alert_titleRow__RvR3b","title":"Alert_title__CxNMx","body":"Alert_body__TtTq+"};